import { Configuration, PopupRequest } from '@azure/msal-browser';
import { Config } from './index';

// MSAL configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: Config.auth.azure.clientId,
    authority: `https://login.microsoftonline.com/${Config.auth.azure.tenantId || 'common'}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};



// Add scopes for API access — uses custom API scope for proper JWT audience
export const loginRequest: PopupRequest = {
  scopes: ['api://a3-platform/access_as_user', 'openid', 'profile', 'email'],
};

// Scopes for API calls — must match the API app registration's "Expose an API" scope
export const apiRequest = {
  scopes: ['api://a3-platform/access_as_user'],
};